// extracted by mini-css-extract-plugin
export default {"hidden":"flex-animation-module-adef5e7d1a662dbaee82","col":"flex-animation-module-c2f5c8672eb5c9deb76d","row":"flex-animation-module-b900678fc3f92424b3eb"};